// DCM/Campaign Manager 360 Floodlight tags — see "Kasturi DCM Pixel Guide".
// Advertiser ID: DC-17533983.

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

export const FLOODLIGHT_ACTIVITIES = {
  allSite: 'DC-17533983/stand0/kastu0+standard',
  homePage: 'DC-17533983/stand0/kastu000+standard',
  homeBuyNowButton: 'DC-17533983/stand0/kastu001+standard',
  homeOurProductsButton: 'DC-17533983/stand0/kastu002+standard',
  homeShopButton: 'DC-17533983/stand0/kastu003+standard',
  productListingPage: 'DC-17533983/stand0/kastu004+standard',
  plpShopOnBlinkitButton: 'DC-17533983/stand0/kastu005+standard',
  plpShopOnAmazonButton: 'DC-17533983/stand0/kastu006+standard',
  productStandalonePage: 'DC-17533983/stand0/kastu00a+standard',
  pdpBuyOnAmazonButton: 'DC-17533983/stand0/kastu007+standard',
  pdpBuyOnFlipkartButton: 'DC-17533983/stand0/kastu008+standard',
  contactUsPage: 'DC-17533983/stand0/kastu009+standard',
  contactUsFormSubmission: 'DC-17533983/stand0/kastu00-+standard',
} as const;

export function fireFloodlightPixel(sendTo: string) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', 'conversion', {
    allow_custom_scripts: true,
    u1: window.location.href,
    u2: document.referrer,
    send_to: sendTo,
  });
}
